<template>
    <div
        class="container-history-earn-point coffee-changetel main-layout addcode"
    >
        <HeaderTitleSvg :setHref="'editprofile'" :showLogo="true" />
        <div v-if="isLoaded" class="wrapper-table-history-point">
            <div class="logo">
                <img src="@/assets/home/logo-new-theme.png" />
            </div>
            <form ref="form-profile">
                <!--  -->
                <div class="box-changetel">
                    <div class="text-center">
                        <div class="h-title">เปลี่ยนหมายเลขโทรศัพท์</div>
                        <div class="title">
                            กรุณาใส่เบอรโทรศัพท์ที่คุณต้องการเปลี่ยน
                        </div>
                    </div>
                    <div class="number-container mb-2 text-center">
                        <InputContactNumber
                            inputId="contact-number"
                            delimeter="-"
                            :inputLbl="lbl.profile.contactnumber"
                            :isFirstSave="isFirstSave"
                            :isShowErrorLbl="true"
                            v-model="modelProfile.ContactNo"
                            :errorInfo="errorInfo[2]"
                            :showLabel="false"
                            @input="onChange()"
                        />
                    </div>
                    <div v-if="isErrorMessage" class="error-message">
                        {{ errorMessage }}
                    </div>
                    <div class="modal-base-footer row box-footer">
                        <div class="btn-submit-wrapper">
                            <div
                                :class="{ disabled: !errorInfo[2].isValid }"
                                class="btn-submit"
                                @click="gotoOTP"
                            >
                                ยืนยัน
                            </div>
                        </div>
                    </div>
                </div>
                <!--  -->
            </form>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
// helper
// import Util from '@/helper/Utility.js';
// import Locale from '@/helper/locale/locale.js';
import Account from "@/helper/AccountHelper.js";
//mixin
import Mixin from "@/mixin/Mixin";
import AccountMixin from "@/mixin/AccountMixin.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";
// component
import InputContactNumber from "@/components/Input/ChangeContactNumber.vue";
import FormHelper from "@/helper/FormHelper.js";
import HeaderTitleSvg from "@/components/Header/HeaderTitleSvg.vue";
import TimerHelper from "@/helper/TimerHelper.js";
// Service
import BzbsProfile from "@/core/Account/service/BzbsProfile.js";
import BzbsApi from "@/core/Account/service/BzbsProfile.js";
import CacheHelper from "@/helper/CacheHelper.js";
// import moment from "moment";
import BzbsOtp from "@/core/Otp/service/BzbsOtp.js";
export default {
    name: "editprofile",
    components: {
        InputContactNumber,
        HeaderTitleSvg,
    },
    mixins: [Mixin, AccountMixin, LocaleMixin, ErrorApiMixin],
    data: function () {
        return {
            cacheHelper: new CacheHelper(),
            // lbl: Locale.getLbl(),
            isLogin: false,
            objProfile: {},
            modelProfile: null,
            isFirstSave: true,
            errorInfo: [],
            errorResponse: "",
            isLoaded: false,

            isDisabledSubmit: true,

            bzbConfig: Vue.bzbsConfig,

            timeHelper: new TimerHelper(),
            isExpireTime: false,
            otp: "",
            tel: "",
            refcode: "",
            channel: "ssoregis",
            resend: false,

            isErrorMessage: false,
            errorMessage: "",
        };
    },
    created: function () {
        this.setupForm();
        this.getProfile();
    },
    methods: {
        formatted: function (input) {
            var n1, n2, n3;
            if (input) {
                n1 = input.substr(0, 3);
                n2 = input.substr(3, 3);
                n3 = input.substr(6);
                input = n1 + "-" + n2 + "-" + n3;
            }
            return input;
        },
        //#region mixin function
        accountInitiated: function () {
            this.objUser = Account.getCacheUser();
            this.modelProfile = this.objProfile;
            // console.log(this.modelProfile);
        },
        async getProfile() {
            this.handleLoading(true);

            try {
                const res = await BzbsApi.getProfileSSO(
                    this.cacheHelper.getCache("BzbsUser").token
                );
                this.objProfile = res.data.SSOUser;
                console.log(this.objProfile, "objProfile");
                let fullName = `${this.objProfile.FirstName} ${this.objProfile.LastName}`;
                this.modelProfile.firstName = fullName;
                this.modelProfile.ContactNo = this.objProfile.ContactNumber;
                this.modelProfile.gender = this.objProfile.Gender;
                this.modelProfile.email = this.objProfile.ProEmail;
                this.modelProfile.zipcode = this.objProfile.Zipcode;
                this.modelProfile.province = this.objProfile.ProvinceName;
                this.modelProfile.districtName = this.objProfile.DistrictName;
                this.modelProfile.subDistrictName =
                    this.objProfile.SubDistrictName;
                // if (this.objProfile.birthDate) {
                //     // format date
                //     var date = moment.unix(this.objProfile.birthDate).utc();
                //     var y = date.format("YYYY");
                //     var m = date.format("M");
                //     var d = date.format("D");
                //     this.modelProfile.birthDate = new Date(y, m, d);
                // }

                this.isLoaded = true;
                this.handleLoading(false);
            } catch (err) {
                this.errorResponse(err, true);
            }
        },
        setupForm: function () {
            var { getList, add } = FormHelper.GenderListValue();
            add("ชาย", "male", "ic_active.png", "ic_inactive.png");
            add("หญิง", "female", "ic_active.png", "ic_inactive.png");
            add("ไม่ระบุ", "notspecified", "ic_active.png", "ic_inactive.png");
            this.prefixValue = getList();

            this.errorInfo = FormHelper.genErrorInfo(20);
        },
        gotoOTP: function () {
            // this.$router.push({
            //     name: "otpchangetel",
            //     query: {
            //         tel: this.modelProfile.ContactNo
            //     }
            // });
            this.handleLoading(true);
            this.apiRequestOtp();
        },
        clickSaveProfile: function () {
            this.isFirstSave = false;

            let token = Account.getToken();

            let nameArray = this.modelProfile.firstName.split(/(\s+)/);

            this.modelProfile.firstName = nameArray[0];
            this.modelProfile.LastName = nameArray[2];

            let params = this.modelProfile;

            console.log(this.modelProfile);

            // this.controller.loadingModal.show();
            BzbsProfile.updateProfile(token, params).subscribe(
                (data) => {
                    this.$bvModal.show("modalSuccessUpdate");
                    console.log(data);
                },
                (err) => {
                    this.$bvModal.show("modalFailUpdate");
                    console.log(err);
                }
            );
        },
        onDatePickerSelected: function (obj) {
            console.log(obj.timestamp);
            this.modelProfile.birthDate = obj.timestamp;
        },
        onFormChange: function () {
            this.$emit("onFormChange");
        },
        changeTel: function () {
            this.$router.push("/changetel");
        },
        //#region otp
        onclickOtp: async function () {
            this.tel = this.modelProfile.ContactNo;
            await this.apiRequestOtp();
            //set timeout to 5 minutes
            this.timeHelper.initialTimer(60 * 5, null, false, false);
            this.startOtp();
            this.$bvModal.show("modalVerifyOtp");
        },
        apiRequestOtp: async function () {
            return new Promise((resolve, reject) => {
                BzbsOtp.requestOtp(
                    this.modelProfile.ContactNo,
                    null,
                    this.channel
                ).subscribe(
                    (data) => {
                        this.refcode = data.refcode;
                        this.$router.push({
                            name: "otpchangetel",
                            query: {
                                tel: this.modelProfile.ContactNo,
                            },
                        });
                        this.handleLoading(false);
                        resolve(true);
                    },
                    (err) => {
                        console.log(err);
                        this.isErrorMessage = true;
                        let errMsg = err.message;
                        if (err.id == 2078) {
                            errMsg =
                                "ขออภัยค่ะ หมายเลขโทรศัพท์ของท่านมีอยู่แล้วในระบบ กรุณาตรวจสอบอีกครั้ง หากไม่สามารถแก้ไขได้ กรุณาติดต่อศูนย์บริการลูกค้า โทร. 02-6578625";
                        }
                        this.errorMessage = errMsg;
                        this.handleLoading(false);

                        reject(false);
                    }
                );
            });
        },
        startOtp: async function () {
            this.isExpireTime = false;
            if (this.resend === false) {
                this.tel = this.modelProfile.ContactNo;
            } else {
                this.timeHelper.stopTimer();
                this.timeHelper.resetTimer();
            }

            this.otp = "";

            this.isErrorMessage = false;

            this.timeHelper.runTimer(() => {
                this.setTimeout();
            });
            this.isExpireTime = true;
        },
        cancelOtp: function () {
            this.timeHelper.stopTimer();
            this.timeHelper.resetTimer();

            this.$store.commit("setDupphone", {
                isdup: false,
                message: "",
            });
        },
        onOtpChange: function () {
            this.otp = this.otp.replace(/\D/g, "");
        },
        setTimeout: function () {
            this.timeHelper.stopTimer();
            this.timeHelper.resetTimer();
            this.isExpireTime = false;
        },
        onSubmitOtp: async function () {
            if (this.validateOtp()) {
                await this.apiValidateOtp();
            }
            this.$bvModal.hide("modalVerifyOtp");
        },
        apiValidateOtp: async function () {
            console.log(this.refcode);
            return new Promise((resolve, reject) => {
                BzbsOtp.validateNestleOtp(
                    this.tel,
                    this.refcode,
                    this.otp
                ).subscribe(
                    (data) => {
                        console.log(data);
                        resolve(true);
                    },
                    (err) => {
                        this.isErrorMessage = true;
                        this.errorMessage = err.message;
                        if (err.message === "รหัส OTP ไม่ถูกต้อง") {
                            this.errorMessage =
                                "รหัส OTP ไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง";
                        }
                        this.isExpireTime = false;
                        console.log(this.errorMessage);
                        reject(false);
                    }
                );
            });
        },
        validateOtp: function () {
            if (this.otp.length != 6) {
                this.errorMessage = this.lbl.otp.otpLength;
                if (this.otp == "") {
                    this.errorMessage = this.lbl.otp.requireInput;
                }
                this.isErrorMessage = true;
                return false;
            }

            return true;
        },
        resendOtp: async function () {
            this.isExpireTime = false;
            this.isErrorMessage = false;

            await this.clickResend();
            this.resend = true;
            await this.startOtp();
        },
        clickResend: async function () {
            return new Promise((resolve, reject) => {
                BzbsOtp.requestOtp(this.tel, null, this.channel).subscribe(
                    (data) => {
                        this.refcode = data.refcode;
                        resolve(true);
                    },
                    (err) => {
                        // this.controller.loadingModal.hide();
                        // if (err.id == 2078) {
                        //     this.controller.alertModal
                        //         .clearText()
                        //         .setMsg(err.message)
                        //         .show();
                        //     this.controller.alertModal.onClickOk(() => {
                        //         this.controller.sendCallbackError(err);
                        //     });
                        // } else {
                        //     this.errorResponse(err);
                        // }
                        console.log(err);
                        reject(false);
                    }
                );
            });
        },
        onChange: function () {
            this.isErrorMessage = false;
            this.errorMessage = "";
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/module/Profile/style/changetel.scss";
</style>
